import { createContext, useContext, type ReactNode } from "react";

export type PhoneJsonEditorContextValue = {
  versionId: string;
  caseId: string;
};

const PhoneJsonEditorContext =
  createContext<PhoneJsonEditorContextValue | null>(null);

export function PhoneJsonEditorProvider({
  versionId,
  caseId,
  children,
}: {
  versionId: string;
  caseId: string;
  children: ReactNode;
}) {
  return (
    <PhoneJsonEditorContext.Provider value={{ versionId, caseId }}>
      {children}
    </PhoneJsonEditorContext.Provider>
  );
}

export function usePhoneJsonEditor(): PhoneJsonEditorContextValue | null {
  return useContext(PhoneJsonEditorContext);
}
